
import { defineComponent } from 'vue';
import GridLine from '@/components/GridLine.vue';

export default defineComponent({
  name: 'Error404',
  components: {
    GridLine,
  },
});
